import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  fromEvent,
  interval,
  race,
  Subscription,
  switchMap,
  takeUntil,
} from 'rxjs';

@Component({
  selector: 'hld-zoom-slider',
  templateUrl: './zoom-slider.component.html',
  styleUrls: ['./zoom-slider.component.scss'],
})
export class ZoomSliderComponent implements OnInit, OnChanges, OnDestroy {
  private zoomInSubscription: Subscription;
  private zoomOutSubscription: Subscription;

  @ViewChild('zoomIn', { static: true }) zoomInEl: ElementRef;
  @ViewChild('zoomOut', { static: true }) zoomOutEl: ElementRef;

  @Input() zoomLevel: number;
  @Input() maxZoom: number;
  @Input() minZoom: number;
  @Input() zoomStep: number;
  @Output() zoomChange = new EventEmitter<number>();
  displayZoomLevel = 100;

  ngOnInit(): void {
    this.displayZoomLevel = this.zoomLevel * 100;

    this.zoomInSubscription = fromEvent(
      this.zoomInEl.nativeElement,
      'mousedown'
    )
      .pipe(
        switchMap(() =>
          interval(50).pipe(
            takeUntil(
              race(
                fromEvent(this.zoomInEl.nativeElement, 'mouseup'),
                fromEvent(this.zoomInEl.nativeElement, 'mouseout')
              )
            )
          )
        )
      )
      .subscribe(() => {
        if (this.zoomLevel + this.zoomStep <= this.maxZoom) {
          this.zoomLevel += this.zoomStep;
          this.displayZoomLevel = this.zoomLevel * 100;
          this.zoomChange.emit(this.zoomLevel);
        }
      });

    this.zoomOutSubscription = fromEvent(
      this.zoomOutEl.nativeElement,
      'mousedown'
    )
      .pipe(
        switchMap(() =>
          interval(50).pipe(
            takeUntil(
              race(
                fromEvent(this.zoomOutEl.nativeElement, 'mouseup'),
                fromEvent(this.zoomOutEl.nativeElement, 'mouseout')
              )
            )
          )
        )
      )
      .subscribe(() => {
        if (this.zoomLevel >= this.minZoom) {
          this.zoomLevel -= this.zoomStep;
          this.displayZoomLevel = this.zoomLevel * 100;
          this.zoomChange.emit(this.zoomLevel);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.zoomLevel.currentValue * 100 !== this.displayZoomLevel) {
      this.displayZoomLevel = this.zoomLevel * 100;
    }
  }

  ngOnDestroy(): void {
    if (this.zoomInSubscription) {
      this.zoomInSubscription.unsubscribe();
    }
    if (this.zoomOutSubscription) {
      this.zoomOutSubscription.unsubscribe();
    }
  }
}
